class vendeurHelper{

    //获取优惠券的描述
    static getCouponDescription(remise) {
        let description = 'Ce coupon est ';
        // '本优惠券是 实际金额折扣/百分比折扣 类型，是 物流/订单 优惠, 最低满100/最高满1000/无满减限制 ,可以减免 100元/10%,有效期为2010-2022/无有效期';
        if (remise.type === 'pourcentage') {
            description += 'Pourcentage de réduction type,'
        } else description += 'Décote sur le montant réel type,';
        if (remise.id_remise_type===1){
            description += 'C’est une offre logistique,'
        }else if (remise.id_remise_type===2){
            description += 'C’est une offre sur commande,'
        }
        if (remise.montant_min) description += `minimum ${remise.montant_min},`;
        if (remise.montant_max) description += `Jusqu’à ${remise.montant_max},`;
        if (!remise.montant_min && !remise.montant_max) description += 'Pas de limitation du montant à utiliser,';
        description += `Réduction ${remise.montant} ${remise.type === 'pourcentage' ? '%' : '€'},`;
        if (remise.date_debut) description += `Valable pour ${remise.date_debut} `;
        if (remise.date_fin) description += `Valable jusqu’au ${remise.date_fin} `;
        if (!remise.date_debut && !remise.date_fin) description += `Pas de limitation dans le temps`;
        return description;
    }
}
module.exports = vendeurHelper;
